<eca-monotron></eca-monotron>

<eca-monotron-body>
  @if (pending$ | async; as pending) {
    <ol class="breadcrumb eca-monotron-breadcrumb">
      <li class="breadcrumb-item">
        <a routerLink="{{previousUrl}}">
          {{submitText}}
        </a>
      </li>
      <li class="breadcrumb-item">Document ID: {{pending.lithocode}}</li>
    </ol>
    <h1 class="eca-skip-link-focus-target" tabindex="-1">Review & Edit</h1>
    <div class="eca-monotron-pipes">
      <div>Student Name: {{pending.firstName}}, {{pending.lastName}} Form/Level: {{pending.form}}</div>
    </div>
  }

  <mat-tab-group #navTabGroup (selectedTabChange)="onTabChanged($event)" [style.margin-top]="'20px'" [style.align-items]="'center'">
    @for (navLink of navLinks; track navLink.path) {
      <mat-tab
        [disabled]="navLink.disabled$ | async"
        label="{{navLink.label}}">
      </mat-tab>
    }
  </mat-tab-group>

  <router-outlet></router-outlet>
</eca-monotron-body>


